<template>
  <el-menu
    router
    :default-openeds="defaultOpened"
    :default-active="activeIndex"
  >

    <template v-for="(item, index) in menuItemsFiltered">
      <el-menu-item
        v-if="!item.children"
        :index="`${index}`"
        :key="index"
        @click="openLink(item.route)"
        >
        <div class="admin-menu-item-title">{{item.title}}</div>
      </el-menu-item>
      <el-submenu
        v-else
        :index="`${index}`"
        :key="index"
        >
        <template slot="title">
          <div class="admin-menu-item-title">{{item.title}}</div>
        </template>
        <el-menu-item
          v-for="(childItem, childIndex) in item.children"
          :index="`${index}-${childIndex}`"
          :key="childIndex"
          @click="openLink(childItem.route)"
        >
          <div class="admin-menu-item-title">{{childItem.title}}</div>
        </el-menu-item>
      </el-submenu>
    </template>
    <el-menu-item @click="logout">
      <div>Выход</div>
    </el-menu-item>
  </el-menu>
</template>
<script>
import {actionTypes} from '@/store/modules/auth'
import {mapState} from 'vuex'

export default {
  name: 'AdminMenu',
  data() {
    return {
      menuItems: [
        {
          title: 'Список заявителей',
          route: {
            name: 'applications',
          },
          permission: 'access_applications',
        },
        {
          title: 'Список вселенных',
          route: {
            name: 'settlement',
          },
          permission: 'access_settlement',
        },
        {
          title: 'Список выселенных',
          route: {
            name: 'evicted',
          },
          permission: 'access_evicted',
        },
        {
          title: 'Архив',
          route: {
            name: 'archive',
          },
          permission: 'access_archive',
        },
        {
          title: 'Корзина',
          route: {
            name: 'basket',
          },
          permission: 'access_basket',
        },
        {
          title: 'Настройки',
          route: {
            name: 'settings',
          },
          permission: 'view_settings',
        },
        {
          title: 'Настройки формы',
          route: {
            name: 'form-settings',
          },
          permission: 'access_form_settings',
          children: [
            {
              title: 'Общие',
              route: {name: 'form-settings-general',},
            },
            {
              title: 'Социальные статусы',
              route: {name: 'form-settings-social-statuses',}
            },
            {
              title: 'Методы оплаты',
              route: {name: 'form-settings-payment-methods',}
            },
            {
              title: 'Места обучения',
              route: {name: 'form-settings-study-places',}
            },
          ]
        },
        {
          title: 'Статьи',
          route: {
            name: 'articles',
          },
          permission: 'view_article',
        },
        {
          title: 'Пользователи',
          route: {
            name: 'users',
          },
          permission: 'view_user',
        },
        {
          title: 'Журнал действий',
          route: {
            name: 'journal',
          },
          permission: 'access_journal',
        },
      ],
      activeIndex: '',
      defaultOpened: []
    }
  },
  mounted(){
    this.redirectIfAdminIndex()
  },
  computed: {
    ...mapState({
      permissions: state => state.auth.permissions
    }),
    menuItemsFiltered() {
      //let permissions = getItem('permissions')
      let permissions = this.permissions
      let items = this.menuItems.filter((item) => {
        let hasAccess = false

        permissions.forEach((permission) => {
          if (permission.codename == item.permission) hasAccess = true
        })

        return hasAccess
      })

      return items
    },
  },
  methods: {
    openLink(route){
      this.$router.push(route)
    },
    logout() {
      this.$store.dispatch(actionTypes.logout)
      this.$router.push({name: 'login'})
    },
    redirectIfAdminIndex(){
      if(
          this.menuItemsFiltered.length > 0
          && this.$route.name === 'admin-index'
          && this.$route.name !== this.menuItemsFiltered[0].route.name
      ){
        this.$router.push({name: this.menuItemsFiltered[0].route.name})
      }
    }
  },
  watch: {
    menuItemsFiltered(){
      this.redirectIfAdminIndex()

      this.menuItems.map((item, index) => {
        if(item.route.name === this.$route.name){
          this.activeIndex = `${index}`
        }

        if(item.children) {
          this.defaultOpened.push(`${index}`)
          item.children.map((childItem, childIndex) => {
            if(childItem.route.name === this.$route.name){
              this.activeIndex = `${index}-${childIndex}`
            }
          })
        }
      })
    },
  }
}
</script>
